import styled, { css } from 'styled-components';
import { Form as BootstrapFormComponent } from 'react-bootstrap';
import TextField from 'components/layout/form/textField';

interface ButtonNavigatorProps {
  active?: boolean;
}

export const Container = styled.div``;

export const PageTitle = styled.div`
  width: 100%;
  color: #262626;
  margin-top: 1.5rem;
  margin-bottom: 21px;
  font-size: 1.3rem;
  font-weight: bold;
`;

export const Separator = styled.hr`
  border-color: #c1c1c1;
  border-style: dashed;
  margin: 10px 0px 20px 0px;
`;

export const Form = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  @media (max-width: 1230px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Box = styled.div`
  width: 100%;
  margin-bottom: 30px;
  padding-right: 20px;
  @media (max-width: 768px) {
    max-width: 100%;
    padding-right: 0px;
  }
`;

export const BootstrapForm = styled(BootstrapFormComponent)``;

export const InputText = styled(TextField)``;

export const ButtonsWrap = styled.div`
  margin-bottom: 16px;

  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ButtonNavigator = styled.button<ButtonNavigatorProps>`
  padding: 8px 16px;
  border-radius: 4px;
  min-width: 172px;
  font-weight: bold;

  border: 2px solid #7f7f7f;
  background: #fff;
  color: #7f7f7f;
  cursor: pointer;

  border-radius: 4px;
  min-width: 156px;
  & + button {
    margin-left: 16px;
  }

  ${({ active }) =>
    active &&
    css`
      border: 2px solid #000fff;
      background: #000fff;
      color: #fff;
    `}

  &:hover {
    filter: opacity(0.6);
  }

  @media (max-width: 600px) {
    & + button {
      margin-left: unset;
      margin-top: 16px;
    }
  }
`;
